import { __assign } from "tslib";
import { makeStyles } from '@material-ui/core';
export var useCardStyles = function (_a) {
    var isOnClickEnabled = _a.isOnClickEnabled, enableHover = _a.enableHover;
    return makeStyles(function (theme) { return ({
        root: __assign({ boxShadow: '0px 2px 4px 0px rgba(0,0,0,0.08)', cursor: isOnClickEnabled ? 'pointer' : 'normal', transition: 'transform ease-in-out 0.15s, box-shadow ease-in-out 0.15s' }, (enableHover && {
            '&:hover': {
                transform: "translateY(-" + theme.spacing(1) + "px)",
                boxShadow: '0px 6px 10px 2px rgba(0,0,0,0.08)',
            },
        })),
    }); });
};
//# sourceMappingURL=Card.styled.js.map